import { cdnURL } from 'utils/helpers';

export const BubblePopBackgrounds = [
  {
    filename: 'background1.png',
    image_url: cdnURL('bubble_pop_bg1.png')
  },
  {
    filename: 'background2.png',
    image_url: cdnURL('bubble_pop_bg2.png')
  }
];
